import { render, staticRenderFns } from "./ThumbsUp.vue?vue&type=template&id=333b2385&scoped=true&"
import script from "./ThumbsUp.vue?vue&type=script&lang=js&"
export * from "./ThumbsUp.vue?vue&type=script&lang=js&"
import style0 from "./ThumbsUp.vue?vue&type=style&index=0&id=333b2385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b2385",
  null
  
)

export default component.exports